import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const lytxConfig: TSPConfig = {
  key: 'lytx',
  name: 'Lytx',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>
        In Lytx Developer Portal, go to Login at the top. Log in using Lytx
        account credentials.
      </li>
      <li>
        On the Dashboard, press 'Create API Credential'. This generates the API
        key.
      </li>
      <li>Copy the API key from the dashboard to the input here.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'API Key', name: 'apikey', type: 'text', required: true },
        {
          label: "Pod (e.g. '5')",
          name: 'database',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default lytxConfig;
